import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LoaderComponent } from "../../../general/components/loader/loader.component";
import { GlassPillDirective } from "../../../general/directives/glass-pill.directive";
import { ChangeDetectorRef, Component, ViewChild, OnInit, inject } from "@angular/core";
import { UserDto } from "../../../user/models/user.model";
import { UserService } from "../../../user/services/user.service";
import { tap } from "rxjs";

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatSortModule,
    MatCardModule,
    LoaderComponent,
    GlassPillDirective
  ],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss',
})
export class UserListComponent implements OnInit {
    private userService = inject(UserService);
    private cdr = inject(ChangeDetectorRef);

    dataSource = new MatTableDataSource<UserDto>();
    isLoading = false;
    displayedColumns: string[] = ['lastName', 'firstName', 'username', 'id', 'role', 'stripeId'];
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        this.dataSource.paginator = mp;
    }

    @ViewChild(MatSort) set matSort(ms: MatSort) {
        this.dataSource.sort = ms;
    }

    ngOnInit() {
        this.isLoading = true;
        this.userService.getAllUsers().pipe(tap(users => {
            this.dataSource.data = users;
            this.isLoading = false;
            this.cdr.detectChanges();
        })).subscribe();
    }
}